/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import LoadingButton from '@g17eco/atoms/loading-button';
import React, { useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { isValidEmail } from '../../../utils';
import { IdentityProvider } from '../../../types/sso';
import { IdpLoginContainer } from './IdpLoginContainer';

interface LoginFormParams {
  redirectPath?: string;
  idps?: IdentityProvider[];
}

export const ExternalLoginForm = ({ redirectPath, idps }: LoginFormParams) => {

  const { oktaAuth } = useOktaAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const isValid = isValidEmail(email);

  return <>
    <div className='mt-xs'>
      <input
        autoFocus required={true}
        name='email'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder='Email address'
        type='email'
        className='form-control' />
    </div>

    <LoadingButton
      onClick={() => {
        setLoading(true);
        oktaAuth.signInWithRedirect({ originalUri: redirectPath, loginHint: email }).catch(console.error)
      }}
      disabled={!isValid}
      loading={loading} loadingText='Loading...' type='submit'
      className='btn btn-secondary w-100 my-2'>
      Continue
    </LoadingButton>

    {idps && idps.length ? <div className={'seperator-container'}>
      <div className='separator my-4 text-colour-15'>
        <span className={'mx-2'}>or</span>
      </div>

      <p>Authenticate your account with SSO provider</p>
      <IdpLoginContainer idps={idps} redirectPath={redirectPath} />
    </div> : <></>}

  </>
};
